/*
 * @创建文件时间: 2019-11-21 16:42:59
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-22 20:59:20
 * @联系Qq:1360484677
 * @文件介绍: 机械设备
 */
export default [{
    path: 'bdDeviceTable',
    name: 'bdDeviceTable',
    meta: {
        title: '设备基础信息',
        auth: true
    },
    component: () =>
        import ('@/views/basic/device/bdDeviceTable')
}, {
    path: 'bdDeviceUseRecordTable',
    name: 'bdDeviceUseRecordTable',
    meta: {
        title: '设备使用记录',
        auth: true
    },
    component: () =>
        import ('@/views/basic/device/bdDeviceUseRecordTable')
}, {
    path: 'bdDeviceRepairRecordTable',
    name: 'bdDeviceRepairRecordTable',
    meta: {
        title: '设备维修保养记录',
        auth: true
    },
    component: () =>
        import ('@/views/basic/device/bdDeviceRepairRecordTable')
}, ]